import React from 'react';
import { ProfileHeroLinkedIn } from './components/krystleroth/ProfileHeroLinkedIn';
import { MatchContext } from './components/krystleroth/MatchContext';
import { IntentLinks } from './components/krystleroth/IntentLinks';
import { AgentCapabilities } from './components/krystleroth/AgentCapabilities';
import { PerformanceMetrics } from './components/krystleroth/PerformanceMetrics';
import { MarketsServed } from './components/krystleroth/MarketsServed';
import { ActiveListings } from './components/krystleroth/ActiveListings';
import { SellerReviews } from './components/krystleroth/SellerReviews';
export function KrystleRothApp() {
  const isMatchIntro = true;
  return <div className="min-h-screen bg-brand-offwhite font-sans text-brand-dark selection:bg-brand-forest selection:text-white" data-id="element-610">
      <main data-id="element-611">
        <ProfileHeroLinkedIn data-id="element-612" />
        <MatchContext visible={isMatchIntro} data-id="element-613" />
        <IntentLinks data-id="element-614" />
        <PerformanceMetrics data-id="element-615" />
        <SellerReviews data-id="element-616" />
        <MarketsServed data-id="element-617" />
        <AgentCapabilities data-id="element-618" />
        <ActiveListings data-id="element-619" />
      </main>

      <footer className="bg-brand-dark text-gray-400 py-10 text-center" data-id="element-620">
        <div className="max-w-6xl mx-auto px-6 space-y-3" data-id="element-621">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-622">
            <img src="/eaves_favicon_transparent.png" alt="Eaves" className="h-5 w-5" data-id="element-623" />

            <span className="text-sm text-gray-300 font-serif font-medium" data-id="element-624">
              Eaves Pro
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-4 text-sm mb-4" data-id="element-625">
            <a href="mailto:Krystle@rothgetsresults.com" className="hover:text-white transition-colors" data-id="element-626">

              Krystle@rothgetsresults.com
            </a>
            <span className="text-gray-600" data-id="element-627">·</span>
            <a href="tel:+19096547684" className="hover:text-white transition-colors font-mono" data-id="element-628">

              (909) 654-7684
            </a>
          </div>
          <p className="text-xs text-gray-500" data-id="element-629">
            Keller Williams Realty · Roth Real Estate Group · 1473 Ford St
            Suite 200, Redlands, CA 92373. DRE #01492471. Performance data
            sourced from public records and verified platforms.
          </p>
          <p className="text-xs text-gray-600" data-id="element-630">
            © {new Date().getFullYear()} Eaves Technologies LLC · witheaves.com
          </p>
        </div>
      </footer>
    </div>;
}